import { formatMokaPointCount } from "@/utils/format-moka-point-count";
const getMokaSelfPlayResultMessage = score => {
  if (score > 0) {
    return `Black wins by ${formatMokaPointCount(score)}.`;
  }
  if (score < 0) {
    return `White wins by ${formatMokaPointCount(Math.abs(score))}.`;
  }
  return "The game is a draw.";
};
export { getMokaSelfPlayResultMessage };